import './accordion.scss'

const selectors = {
  accordion: '[data-accordion]',
  accordionItem: '[data-accordion-item]',
  accordionHeader: '[data-accordion-item-header]',
  accordionBody: '[data-accordion-item-body]',
  active: 'active',
}

const handleClick = (active, accordions) => {
  accordions.forEach((accordion) => {
    const isActive = active.accordion.classList.contains(selectors.active)

    accordion.accordion.classList.remove(selectors.active)
    accordion.body.style.height = '0px'

    if (isActive) return

    if (accordion.accordion.isSameNode(active.accordion)) {
      accordion.accordion.classList.add(selectors.active)
      accordion.body.style.height = accordion.body.firstElementChild.clientHeight + 'px'
    }
  })
}

const initAccordion = (container) => {
  let accordions = container?.querySelectorAll(selectors.accordionItem)

  if (!accordions) return

  accordions = Array(...accordions).map((accordion) => {
    const header = accordion.querySelector(selectors.accordionHeader)
    const body = accordion.querySelector(selectors.accordionBody)

    return {
      accordion,
      header,
      body,
    }
  })

  accordions?.forEach((accordion) => {
    accordion.header.addEventListener('click', () => handleClick(accordion, accordions))
  })
}

document.addEventListener('DOMContentLoaded', async function () {
  const containers = document.querySelectorAll(selectors.accordion)

  containers?.forEach(initAccordion)
})
